import { Context } from 'Context/Context';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { getCaseCountApi, markNotificationAsViewedApi, userListCasesApi } from 'Constants';
import SortingOptions from './SortingOptions';
import ApprovedCases from './ApprovedCases';
import NoConflictCases from './NoConflictCases';
import { CaseListLayout, ResultLine, CardSkeleton, CasePager } from './CaseListUI';
import { FilterBar } from './CaseFilters';
import { CASE_TYPES, readCaseType, writeCaseType, useRestoreListScroll } from './CaseStage';

// Active Cases (header menu) — Approved cases · My cases · Not interested
const TYPES = CASE_TYPES['2'];   // shared with the case page (CaseStage.jsx)

function MyActiveCases({attorney,  updateComp, setUpdateComp}) 
{
    // last case type used in this section (kept when coming back from a case page)
    const [innerPanel, setInnerPanel] = useState(() => readCaseType('2', 1));
    const {userDetails, makeApiCallFunc, filters, setFilters,  offset, setOffset, reqRevCountArr, setReqRevCountArr} = useContext(Context);
    const userInfo = attorney ? attorney?.userId :  userDetails;
    const [selectedSort, setSelectedSort] = useState("Date of incident - recent first");
    
    const {setUpdateLoggedinData} = useContext(Context);
    const [sendCount, setSendCount] = useState(true);

    const [caseTypeCount, setCaseTypeCount] = useState(["approved", "noConflict"]);


    const [cases, setCases] = useState(null);
    const fetchSeq = useRef(0);   // ignore responses from superseded requests
    const [count, setCount] = useState({
        "approved" : 0,
        "noConflict" : 0,
        "notInterested" : 0,
    });
    const [isVerified, setIsVerified] = useState(userInfo?.verified);


    const [totalCases, setTotalCases] = useState(0);
    
    const [limit, setLimit] = useState(isVerified? 5 : 3);

    const processReqReviewCount = (data) => {
        let idWithReqReviewArr = null;
        if(data?.length !== 0 )
            {
                idWithReqReviewArr = {}
                data?.map((item) => {
                       // let incrCounter = item.deniedCount !== 0 ? (item.caseStatus === "denied" ? item.deniedCount : parseInt(item.deniedCount) + 1 ) : 1;
                      let incrCounter =  1 ;
                       let statusVariable =  (item.caseStatus === "denied" && item.userId !== userInfo._id) ? "requested" : item.caseStatus;
                        if(idWithReqReviewArr[item.caseId])
                        {   
                            if(idWithReqReviewArr[item.caseId][statusVariable])
                            {
                                idWithReqReviewArr[item.caseId][statusVariable] = item.caseStatus === "denied" ? item.deniedCount : idWithReqReviewArr[item.caseId][statusVariable] + incrCounter; 
                            }
                            else
                            {
                                idWithReqReviewArr[item.caseId][statusVariable] = item.caseStatus === "denied" ? item.deniedCount : incrCounter;
                            }
                        }
                        else
                        {
                            
                            idWithReqReviewArr[item.caseId] = { [statusVariable] : item.caseStatus === "denied" ? item.deniedCount : incrCounter}
                        }
                        
                })  
            }

                console.log(idWithReqReviewArr)
                return idWithReqReviewArr;

    }
    const [sortOptions, setSortOptions] = useState(JSON.stringify({"field" : "dateInfo", "order" : -1}));
    useEffect(() => {
        console.log("useEffect MyActiveCases", offset)
        setCases(null);
        setReqRevCountArr(null);
        setTotalCases(0);
        setCount({
            "approved" : 0,
            "noConflict" : 0,
            "notInterested" : 0
        }) 
        const mine = ++fetchSeq.current;
        makeApiCallFunc(
        getListType(),
        {
            filters,
            sortOptions : JSON.parse(sortOptions),
            sendCount: sendCount,   
            caseTypeCount: caseTypeCount,
            limit: limit,
            offset: offset,
            userId: userInfo?._id
        },
        ({data}) => 
        {
            if (mine !== fetchSeq.current) return;
            setCases(data?.cases || []);
            setTotalCases(data?.totalCount ? data?.totalCount : 0);
            setReqRevCountArr(processReqReviewCount(data?.userCaseStatusCount))
            // let currentTab = innerPanel === 0 ? "approved" : innerPanel === 1 ? "noConflict" : "notInterested";
            // setCount(prev => ({...prev, [currentTab] : data?.[0]?.totalCount}));
                 
        },
        (data) => { console.log(data); if (mine === fetchSeq.current) setCases([]); },
        null,
        true
        )
        // makeApiCallFunc(
        //     getListType(),
        //     {
        //         filters,
        //         sortOptions : JSON.parse(sortOptions),
        //         sendCount: sendCount,   
        //         caseTypeCount: caseTypeCount,
        //         limit: limit,
        //         offset: offset,
        //         loadReqRev: true,
        //     userId: userInfo?._id
                

        //     },
        //     ({data}) => 
        //     {
        //         setReqRevCountArr(processReqReviewCount(data))
        //     },
        //     (data) => { console.log(data)},
        //     null,
        // true
        //     ) 
        console.log("getCasesCountApi")
        makeApiCallFunc(getCaseCountApi,
            {
                userId: userInfo?._id,
                statuses: ["approved", "noConflict", "notInterested"],
                takeTeamup: true
            },
            ({data}) => 
            {
                if(data.length === 0 )
                    { 
                    setCount({
                        "approved" : 0,
                        "noConflict" : 0,
                        "notInterested" : 0
                    }) 
                }
                else
                {
                    data?.map((item) => {
                        console.log(item)
                        return setCount(prev => ({...prev, [item._id] : item.count}))
                    })
                }
            
            console.log(data);

            },
            (data) => { 
                console.log("getcasescountapi error")
                console.log(data)},
            null,
            true
            )
    },[updateComp, innerPanel, offset])
   
    
    const current = TYPES.find((t) => t.key === innerPanel) || TYPES[1];
    const emptyText = { title: 'No ' + current.label.toLowerCase() + ' yet', body: 'Cases will appear here as they move into this stage. Try changing your filters.' };
    const builder = (activePanel) => {
            switch (activePanel)
            {
                case 0 :
                return <ApprovedCases attorney={attorney} reqRevCountArr={reqRevCountArr}  cases={cases} setUpdateComp={setUpdateComp} emptyText={emptyText}
                />
                case 1 :
                return <NoConflictCases attorney={attorney} reqRevCountArr={reqRevCountArr}  cases={cases} setUpdateComp={setUpdateComp} emptyText={emptyText}
                />
                case 2 :
                return <NoConflictCases attorney={attorney} reqRevCountArr={reqRevCountArr} cases={cases}  setUpdateComp={setUpdateComp} emptyText={emptyText}/>
                default:
                return null
            }
    }
    const getListType =() => 
    {
        switch (innerPanel)
            {
                case 0 :
                return userListCasesApi+"approved"
                case 1 :
                    return userListCasesApi+"noConflictInterestedCases"
                case 2 :
                    return userListCasesApi+"noConflictNotInterestedCases"
                default:
                return userListCasesApi+"approved"

            }
    }
    const selectType = (key) => {
        if (key === 0) {
            makeApiCallFunc(markNotificationAsViewedApi,
                { userId: userDetails?._id, updateData: { isActiveNotificationViewed: true } },
                () => setUpdateLoggedinData(prev => !prev),
                () => console.log("error in notification viewed"),
                null, true
            );
        }
        setOffset(0);
        setInnerPanel(key);
        writeCaseType('2', key);
    };
    useRestoreListScroll('2', cases !== null);
    const railItems = TYPES.map((t) => ({
        ...t,
        count: t.key === 0 ? (count?.approved || 0) : t.key === 1 ? (count?.noConflict || 0) : (count?.notInterested || 0),
        // Approved cases wait on the attorney (check for conflict) - dot while any are there
        dot: t.key === 0 && (Number(count?.approved) || 0) > 0,
    }));
    const countFor = (draft) => ({
        url: getListType(),
        body: { filters: draft, sortOptions: null, limit: 1, offset: 0, userId: userInfo?._id },
        pick: (d) => (d?.totalCount || 0),
    });

  return (
    <CaseListLayout
        attorney={attorney}
        sectionKey="2"
        railItems={railItems}
        activeKey={innerPanel}
        onSelect={selectType}
        setUpdateComp={setUpdateComp}
    >
        <FilterBar attorney={attorney} setUpdateComp={setUpdateComp} countFor={countFor}/>
        <ResultLine
            label={current.label}
            total={totalCases}
            loading={!cases}
            right={<SortingOptions setOffset={setOffset} setUpdateComp={setUpdateComp} sortOptions={sortOptions} setSortOptions={setSortOptions} selectedSort={selectedSort} setSelectedSort={setSelectedSort}/>}
        />
        {cases ? builder(innerPanel) : <CardSkeleton/>}
        <CasePager
            offset={offset}
            limit={limit}
            total={isVerified ? totalCases : offset + (cases?.length || 0)}
            shown={cases?.length || 0}
            onPage={(next) => setOffset(next)}
        />
    </CaseListLayout>
  )
}

export default MyActiveCases
